import React from "react";

const HoDrivewayRoad = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label="Driveway / Road"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <filter id="softShadow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Road body (white) */}
    <path
      d="M26 64 L38 64 L46 20 Q32 10 18 20 Z"
      fill="#ffffff"
      filter="url(#softShadow)"
    />

    {/* Side lines (black) */}
    <path d="M18 20 L26 64" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
    <path d="M46 20 L38 64" stroke="#000000" strokeWidth="2" strokeLinecap="round" />

    {/* Center dashed line (black) */}
    <path d="M32 60 V54" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 50 V44" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 40 V34" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 30 V24" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default HoDrivewayRoad;
